<div class="scanner-wrap" tabindex="-1" focusElement>
    <div class="scanner-header">
        <div class="title">
            <span>{{pageConstants.scanPassLabel}}</span>
        </div>
        <button class="close-wrap unstyle-button" (click)="closeScanner()" >
            <i aria-hidden="true" class="material-icons">close</i>
        </button>
    </div>
    <div class="scanner-body"></div>
    <div class="scanner-footer">
        <span>{{pageConstants.scannerInfo}}</span>
    </div>
</div>
